/** biome-ignore-all lint/style/noMagicNumbers: TODO: check */
import { type FC, Fragment, memo, type ReactNode } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'antd';

import { NVISION_USER_TYPES } from '@/contants/common';
import type { RootState } from '@/redux/RootReducer';

import { setFilterToggle } from '../../../redux/common/CommonActions';
import FilterCard from '../../components/Cards/FilterCard';

interface WithFilterProps {
  filterElement?: ReactNode;
  contentElement?: ReactNode;
  filterTitle?: string;
  pageTitle?: string;
  footerContent?: ReactNode;
  headerContent?: ReactNode;
  isPageTitle?: boolean;
  filterCardWidth?: number;
  contentCardWidth?: number;
  labelForTestId?: string;
}

const WithFilter: FC<WithFilterProps> = ({
  filterElement,
  contentElement,
  filterTitle,
  pageTitle,
  footerContent,
  headerContent,
  isPageTitle = true,
  filterCardWidth,
  contentCardWidth,
  labelForTestId,
}) => {
  const filterVisible = useSelector((state: RootState) => state.common.filterVisible);
  const userDetails = useSelector((state: RootState) => state.auth.user.data);
  const dispatch = useDispatch();

  const filterCardLayouts = filterVisible
    ? { lg: filterCardWidth || 5, sm: 24, xl: filterCardWidth || 4, xs: 24 }
    : { lg: 1, sm: 24, xl: 1, xs: 24 };

  const contentCardLayouts = filterElement
    ? filterVisible
      ? {
          lg: contentCardWidth || 19,
          sm: 24,
          xl: contentCardWidth || 20,
          xs: 24,
        }
      : { lg: 23, sm: 24, xl: 23, xs: 24 }
    : { xs: 24 };

  const handleFilterToggle = (data: boolean) => {
    dispatch(setFilterToggle(data));
  };

  return (
    <Row gutter={15} className="h-100 overflow-y-inherit">
      {filterElement && (
        <Col
          {...filterCardLayouts}
          className="h-100 pb-15 overflow-y-inherit d-flex flex-direction-column"
          data-testid={labelForTestId ? `${labelForTestId}-filters` : ''}
        >
          <div
            className={`br-5 box-shadow border-none h-100 overflow-y-inherit d-flex flex-direction-column ${
              filterVisible ? '' : 'filter-card-collapsed'
            }`}
          >
            <FilterCard title={filterTitle} expanded={filterVisible} setExpanded={handleFilterToggle} />
            <div
              className={`py-15 background-white ${
                !filterVisible ? 'd-none' : 'd-flex'
              } flex-direction-column h-100 overflow-y-inherit`}
            >
              {filterElement}
            </div>
          </div>
        </Col>
      )}
      <Col {...contentCardLayouts} className="h-100 pb-15 overflow-hidden d-flex flex-direction-column">
        <div className="overflow-hidden d-flex flex-direction-column flex-1">
          {userDetails?.userType === NVISION_USER_TYPES.CARR
            ? headerContent && <div className="background-white brbl-4 brbr-4">{headerContent}</div>
            : headerContent && (
                <Fragment>
                  {isPageTitle && (
                    <FilterCard title={pageTitle}>
                      <div className="background-white brbl-4 brbr-4">{headerContent}</div>
                    </FilterCard>
                  )}
                  {!isPageTitle && <div className="background-white brbl-4 brbr-4">{headerContent}</div>}
                </Fragment>
              )}
          <div className="overflow-hidden flex-1">{contentElement}</div>
        </div>
        {footerContent && <div>{footerContent}</div>}
      </Col>
    </Row>
  );
};

export default memo(WithFilter);
